import { render } from "./ProfileImageModal.vue?vue&type=template&id=2281a098&scoped=true"
import script from "./ProfileImageModal.vue?vue&type=script&lang=js"
export * from "./ProfileImageModal.vue?vue&type=script&lang=js"

import "./ProfileImageModal.vue?vue&type=style&index=0&id=2281a098&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2281a098"]])

export default __exports__